/**
 * 个股行情图标库
 */
import React from 'react'
import { isIOS } from '../utils'
import './index.less'

export function UnselectIcon() {
  return (
     <a href='#' className="unselect-icon"></a>
  )
}


export function TopArrow() {
  return (
     <a href='#' className="top-arrow"></a>
  )
}


export function SortArrow() {
  return (
     <a href='#' className="sort-arrow"></a>
  )
}


export function SelectIcon() {
  return (
     <a href='#' className="select-icon"></a>
  )
}

export function DeleteIcon() {
  return (
     <a href='#' className="delete-icon"></a>
  )
}

export function DragIcon() {
  return (
     <a href='#' className="drag-icon"></a>
  )
}

export function EditIcon() {
  return (
     <a href='#' className="edit-icon"></a>
  )
}

export function HeaderSearch() {
  return (
     <a href="//wap.eastmoney.com/home/menu" className="header-search"></a>
  )
}

export function StockUpIcon() {
  return (
     <span className="stock-up-icon"></span>
  )
}

export function StockDownIcon() {
  return (
     <span className="stock-down-icon"></span>
  )
}

export function formatDirection(value:any, value1:any) {
  if (value == null || value == "-" || value1 == null || value1 == "-") {
      return "";
  }

  if (parseFloat(value) > parseFloat(value1)) {
      return <StockUpIcon/>;
  } else if (parseFloat(value) < parseFloat(value1)) {
      return <StockDownIcon/>;
  } else {
      return "";
  }
}

export function StockNewUpIcon() {
  return (
     <span className="stock-up-icon-new"></span>
  )
}

export function StockNewDownIcon() {
  return (
    <span className="stock-down-icon-new"></span>
  )
}

export function formatNewDirection(value:any, value1:any) {
  if (value == null || value == "-" || value1 == null || value1 == "-") {
      return "";
  }

  if (parseFloat(value) > parseFloat(value1)) {
      return <StockNewUpIcon />;
  } else if (parseFloat(value) < parseFloat(value1)) {
      return <StockNewDownIcon/>;
  } else {
      return "";
  }
}

export function NavIcon(){
  return (
    <a href='//wap.eastmoney.com/home/menu' className="nav-icon"></a>
 )
}

export function AdviseIcon(){
  return (
    <a href='#' className="advise-icon"></a>
 )
}

export function MobileIcon(){
  return (
    <a href='#' className="mobile-icon"></a>
 )
}

export function StockTradeIcon(){
  return (
    <a href='#' className="stock-trade-icon"></a>
 )
}

export function StockPostIcon(){
  return (
    <a href='#' className="stock-post-icon"></a>
 )
}

export function StockMoreIcon(){
  return (
    <a href='#' className="stock-more-icon"></a>
 )
}

export function StockShareIcon(){
  return (
    <a href='#' className="stock-share-icon"></a>
 )
}

export function StockAddIcon(){
  return (
    <a href='#' className="stock-add-icon"></a>
 )
}

export function StockDeleteIcon(){
  return (
    <a href='#' className="stock-delete-icon"></a>
 )
}

export function ShareWeChatIcon(){
  return (
    <a href="#" className='share-wechat-icon'></a>
  )
}

export function ShareMomentIcon(){
  return (
    <a href="#" className='share-moment-icon'></a>
  )
}

export function ShareQzoneIcon(){
  return (
    <a href="#" className='share-qzone-icon'></a>
  )
}

export function ShareWeiboIcon(){
  return (
    <a href="#" className='share-weibo-icon'></a>
  )
}

export function QuestionIcon(){

  const clickIconQuestion = ()=>{
    window.location.href = '/quote/ahdescription.html';
  }

  return (
    <i className="icon-question" onClick={(e)=>{e.stopPropagation();clickIconQuestion()}}></i>
  )
}

export function LowVersionIcon(){
  return (
    <i className='low-version-icon'></i>
  )
}

export function CloseIcon(){
  return (
    <i className='close-icon'></i>
  )
}